/**!
 * Apricot
 * @version 4.10.6
 * @author Mitra Assadi
 * @license
 * Copyright (c) 2025 The College Board
 */

/* ========================================================================
 * Apricot's Base
 * ======================================================================== */

// SCSS
import '../scss/includes/apricot-base.scss';

if (typeof window !== 'undefined') {
  window.cb = window.cb || {};

  window.cb.apricot = window.cb.apricot || {};

  window.cb.apricot.version = '4.10.6';
}

// javaScript
export default {};
